module.exports = __webpack_public_path__ + "static/media/trainer.c74596e2.svg";